/**
 * 請求先住所フォーマットユーティリティ
 *
 * 修繕履歴画面で請求先情報を表示する際に使用。
 */

/**
 * 郵便番号を 〒XXX-XXXX 形式に整形
 * - 7桁数字 → ハイフン補完
 * - 既にハイフン付き → そのまま
 * - 空文字/undefined → 空文字
 */
export const formatZipCode = (zipCode: string | undefined): string => {
  if (!zipCode) return '';
  const normalized = zipCode.includes('-')
    ? zipCode
    : `${zipCode.slice(0, 3)}-${zipCode.slice(3)}`;
  return `〒${normalized}`;
};

interface BillingAddressFormatInput {
  zipCode: string;
  prefectureName: string;
  addressCity: string;
  addressDetail: string;
  addressBuilding: string;
}

/**
 * 請求先住所を表示用文字列にフォーマット
 *
 * 形式:
 *   〒XXX-XXXX
 *   都道府県市区町村番地建物名
 *
 * 郵便番号が空の場合は〒行を省略。
 * 建物名が空の場合は建物名部分を省略。
 */
export const formatBillingAddress = ({
  zipCode,
  prefectureName,
  addressCity,
  addressDetail,
  addressBuilding,
}: BillingAddressFormatInput): string => {
  const zipLine = formatZipCode(zipCode);
  const addressLine = `${prefectureName}${addressCity}${addressDetail}${addressBuilding}`;

  if (!zipLine && !addressLine) return '';
  if (!zipLine) return addressLine;
  if (!addressLine) return zipLine;
  return `${zipLine}\n${addressLine}`;
};
